import {useLingui} from '@lingui/react/macro';
import {useSelector} from 'react-redux';
import {useCallback, useEffect} from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {useModalUpsellStorage} from 'interface/hooks/useModalUpsellStorage';
import {ProgressBar} from 'interface/base/ProgressBar';
import {bytesize} from 'utils/common/data';
import {openPage} from 'utils/mediafire';
import {isIOS, isSafari} from 'utils/platform';
import {colors} from 'config/styles';
import {theme} from 'config/themes';
import {version} from 'config/app';

import * as app from 'store/slices/app';

export function MenuStorage() {
  const {t} = useLingui();
  const isPremium = useSelector(app.selectors.isPremium);
  const limits = useSelector(app.selectors.getLimits);
  const email = useSelector(app.selectors.getEmail);
  const total = limits ? limits.storage.total : 0;
  const used = limits ? limits.storage.used : 0;
  const percent = Math.max(0, Math.min(100, (used / total) * 100));
  const details = `${bytesize(used)} / ${bytesize(total, 0)}`;
  const hasUpsell = !(isPremium ||  isIOS() || isSafari());

  const openAccount = useCallback(() => openPage('myaccount/'), []);
  const openUpgrade = useCallback(() => openPage('upgrade/?utm_source=sidebar&utm_medium=website&utm_content=upgrade&utm_campaign=upgrade_v1_20210816&mf_source=sidebar&mf_medium=website&mf_content=upgrade&mf_campaign=upgrade_v1_20210816'), []);
  const [showStorageReminder] = useModalUpsellStorage('remind');

  useEffect(() => {
    if (percent >= 95) {
      showStorageReminder();
    }
  }, []);

  return (
    <View style={styles.root}>
      <ProgressBar
        items={[{
          value: percent,
          color: percent < 80
            ? theme.transfers.progress.uploaded
            : colors.secondary.brightRed
        }]}
        texts={[
          {
            style: styles.details,
            value: details,
          },
          {
            onPress: hasUpsell ? openUpgrade : openAccount,
            style: styles.upgrade,
            value: !email
              ? t`Sign up`.toUpperCase()
              : hasUpsell
                ? t`Upgrade`.toUpperCase()
                : t`Account`.toUpperCase(),
        }]}
      />
      <View style={styles.legal}>
        <View style={styles.version}>
          <Text style={styles.copyright}>
            © MediaFire
          </Text>
          <Text style={styles.build}>
            {`v${process.env.REACT_APP_VERSION || version}`}
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    marginVertical: 8,
    marginHorizontal: 16,
  },
  upgrade: {
    fontSize: 10,
    color: colors.secondary.green,
  },
  details: {
    fontSize: 10,
    flex: 1,
    color: colors.neutral.light,
  },
  build: {
    color: colors.neutral.light,
    textAlign: 'right',
    fontSize: 10,
  },
  copyright: {
    color: colors.neutral.light,
    textAlign: 'left',
    fontSize: 10,
    flex: 1,
  },
  version: {
    flex: 1,
    marginBottom: 2,
    flexDirection: 'row',
  },
  legal: {
    flex: 0,
    paddingVertical: 8,
    marginTop: 16,
    borderTopWidth: 1,
    borderColor: 'rgba(255,255,255,0.1)',
  },
});
